export default __webpack_public_path__ + "static/media/cx_cover_bn3.86d17243.jpg";